import { createContext } from "react";

export interface DraftSaveHandle { save: () => Promise<boolean> }
export interface DirtyEditor {
  readonly dirty: boolean;
  readonly priority: number;
  /** Whether the editor connected a saver; one without (a report) offers only keep or drop. */
  readonly saveable: boolean;
  readonly save: () => Promise<boolean>;
}
export interface DraftGuardContextValue {
  register: (id: string, editor: DirtyEditor) => () => void;
  requestClose: (close: () => void, id?: string) => void;
}
export const DraftGuardContext = createContext<DraftGuardContextValue>({
  register: () => () => undefined,
  requestClose: (close) => { close(); },
});
